module.exports = __webpack_public_path__ + "img/emptyImg.7b607753.png";